if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const runAddToCart = () => {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');

              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        };

        // 購入上限タグ（pds-product-cart-rules-json）がある場合のみ、カート内数量と加算後を検証してから追加する
        const metaEl = this.querySelector('script.pds-product-cart-rules-data');
        if (!metaEl) {
          runAddToCart();
          return;
        }

        let meta;
        try {
          meta = JSON.parse(metaEl.textContent);
        } catch (e) {
          const msg =
            window.cartStrings?.error ||
            window.pdsCartRules?.strings?.cartFetchFailed ||
            'カート情報を確認できませんでした。もう一度お試しください。';
          this.handleErrorMessage(msg);
          return;
        }

        // tagMax が無い／0 以下なら購入上限対象外として通常フローへ
        if (!meta || meta.tagMax == null || !(meta.tagMax > 0)) {
          runAddToCart();
          return;
        }

        // 数量はフォーム外ブロックにあり `form` 属性で紐づくため querySelector では見えない。
        // HTMLFormElement.elements には form 属性関連付けされたコントロールも含まれる。
        const namedQty = this.form.elements.namedItem('quantity');
        const qtyInput =
          namedQty && namedQty.nodeType === Node.ELEMENT_NODE
            ? namedQty
            : namedQty && namedQty[0]
              ? namedQty[0]
              : this.form.querySelector('[name="quantity"]');
        const addQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        const productId = meta.productId != null ? Number(meta.productId) : NaN;
        const variantId = parseInt(this.variantIdInput.value, 10);

        const loadCart =
          typeof window.pdsFetchCartJson === 'function'
            ? window.pdsFetchCartJson({ maxAge: 0 })
            : fetch(`${routes.cart_url}.js`).then((r) => {
                if (!r.ok) throw new Error('cart fetch failed');
                return r.json();
              });

        loadCart
          .then((cart) => {
            // 同一商品（product_id）のカート内合計。productId が取れないときだけ variant 単位にフォールバック
            let inCart = 0;
            if (!Number.isNaN(productId)) {
              for (let i = 0; i < cart.items.length; i++) {
                if (Number(cart.items[i].product_id) === productId) inCart += cart.items[i].quantity;
              }
            } else {
              for (let i = 0; i < cart.items.length; i++) {
                if (cart.items[i].variant_id === variantId) inCart += cart.items[i].quantity;
              }
            }
            if (inCart + addQty > meta.tagMax) {
              const fallback = `この商品はカート内で合計${meta.tagMax}個までです。`;
              const msg =
                window.pdsCartRules?.strings?.addOverPurchaseLimit?.replace('[max]', String(meta.tagMax)) || fallback;
              this.handleErrorMessage(msg);
              return;
            }
            runAddToCart();
          })
          .catch(() => {
            const msg =
              window.pdsCartRules?.strings?.cartFetchFailed ||
              window.cartStrings?.error ||
              'カート情報の取得に失敗しました。もう一度お試しください。';
            this.handleErrorMessage(msg);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
